var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a1 1 0 1 0 0-2H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h8a1 1 0 1 0 0-2zm12.707 9.293-4-4a1 1 0 1 0-1.414 1.414L16.586 11H9a1 1 0 1 0 0 2h7.586l-2.293 2.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414",
    clipRule: "evenodd"
  })));
};
export default SvgLogout;